import { ItemData } from 'core/models/Template'

export const DRINKS_CATALOG_TITLE_KEY = 'drinksCatalog' as const

export type DrinksSelectedItems = ItemData[]

export type DrinksSliderProducts = unknown[]
